module.exports = __webpack_public_path__ + "img/Perth_&_Kinross.aba96bcd.png";